import {APPLIED_PARENT_JSON} from "./types";

export const AppliedParentJson= (payload) => ({
    type: APPLIED_PARENT_JSON,
    payload,
});